import React from "react";

import {
    ResponsiveContainer,
    LineChart,
    Line,
    BarChart,
    Bar,
    CartesianGrid,
    XAxis,
    YAxis,
    Tooltip,
    Legend
} from "recharts";

const COLORS = [
    "#2563eb",
    "#dc2626",
    "#059669",
    "#7c3aed",
    "#ea580c",
    "#0891b2",
    "#65a30d",
    "#be123c",
    "#4338ca",
    "#0f766e"
];

const TrendChart = ({
    trendData,
    orgList,
    selectedOrg,
    chartType,
    metric
}) => {

    const series = [selectedOrg];

    const title = (() => {

        switch (metric) {

            case "daily":
                return "Increment Cases";

            case "cumulative":
            default:
                return "Cumulative Cases";

        }

    })();

    return (

        <div
            style={{
                background: "#fff",
                border: "1px solid #e5e7eb",
                borderRadius: 8,
                padding: 20
            }}
        >

            <div
                style={{
                    fontSize: 18,
                    fontWeight: 600,
                    marginBottom: 16
                }}
            >
                {title}
            </div>

            <ResponsiveContainer
                width="100%"
                height={520}
            >

                {

                    chartType === "line"

                        ? (

                            <LineChart
                                data={trendData}
                            >

                                <CartesianGrid strokeDasharray="3 3" />

                                <XAxis
                                    dataKey="date"
                                />

                                <YAxis
                                    allowDecimals={false}
                                />

                                <Tooltip />

                                <Legend />

                                {

                                    series.map((org, index) => (

                                        <Line

                                            key={org}

                                            type="monotone"

                                            dataKey={org}

                                            name={org}

                                            stroke={
                                                COLORS[
                                                index %
                                                COLORS.length
                                                ]
                                            }

                                            strokeWidth={2}

                                            dot={{
                                                r: 3
                                            }}

                                            activeDot={{
                                                r: 6
                                            }}

                                            connectNulls

                                        />

                                    ))

                                }

                            </LineChart>

                        )

                        : (

                            <BarChart
                                data={trendData}
                            >

                                <CartesianGrid strokeDasharray="3 3" />

                                <XAxis
                                    dataKey="date"
                                />

                                <YAxis
                                    allowDecimals={false}
                                />

                                <Tooltip />

                                <Legend />

                                {

                                    series.map((org, index) => (

                                        <Bar

                                            key={org}

                                            dataKey={org}

                                            name={org}

                                            fill={
                                                COLORS[
                                                index %
                                                COLORS.length
                                                ]
                                            }

                                        />

                                    ))

                                }

                            </BarChart>

                        )

                }

            </ResponsiveContainer>

        </div>

    );

};

export default TrendChart;